import { useContext } from 'react';

import { ScreenSizeContext } from '../../ScreenSizeProvider/ScreenSizeProvider';

const useScreenSize = () => useContext(ScreenSizeContext);

export default useScreenSize;
